module.exports = __webpack_public_path__ + "static/media/speaker-demo-profile.d98c530d.jpg";